import { MessageCircle, Phone, Mail, Globe } from 'lucide-react';

export const API_BASE = process.env.REACT_APP_BACKEND_URL || '';

// Treatment categories
export const TREATMENTS = [
  { value: 'cardiac', label: 'Cardiac Surgery & Heart Care' },
  { value: 'orthopedic', label: 'Orthopedic Surgery' },
  { value: 'oncology', label: 'Cancer Treatment (Oncology)' },
  { value: 'neurology', label: 'Neurology & Brain Surgery' },
  { value: 'fertility', label: 'Fertility & IVF Treatment' },
  { value: 'cosmetic', label: 'Cosmetic & Plastic Surgery' },
  { value: 'dental', label: 'Dental Care & Implants' },
  { value: 'eye', label: 'Eye Care & LASIK' },
  { value: 'bariatric', label: 'Bariatric & Weight Loss Surgery' },
  { value: 'transplant', label: 'Organ Transplant' },
  { value: 'spine', label: 'Spine Surgery' },
  { value: 'urology', label: 'Urology Treatment' },
  { value: 'gynecology', label: 'Gynecology & Women Health' },
  { value: 'gastro', label: 'Gastroenterology' },
  { value: 'other', label: 'Other / Not Sure' },
];

// Services
export const SERVICES = [
  { value: 'airport_pickup', label: 'Airport Pickup & Drop' },
  { value: 'language_interpreter', label: 'Language Interpreter' },
  { value: 'accommodation', label: 'Travel & Accommodation' },
  { value: 'nursing_care', label: 'Post-Treatment Nursing Care' },
  { value: 'physiotherapy', label: 'Physiotherapy' },
  { value: 'video_consultation', label: 'Video Consultation' },
  { value: 'visa_assistance', label: 'Visa Assistance' },
  { value: 'local_tours', label: 'Local Tours & Sightseeing' },
  { value: 'all_inclusive', label: 'All-Inclusive Package' },
];

// Countries
export const COUNTRIES = [
  { value: 'AF', label: 'Afghanistan' },
  { value: 'BD', label: 'Bangladesh' },
  { value: 'BH', label: 'Bahrain' },
  { value: 'ET', label: 'Ethiopia' },
  { value: 'GH', label: 'Ghana' },
  { value: 'IQ', label: 'Iraq' },
  { value: 'KE', label: 'Kenya' },
  { value: 'KW', label: 'Kuwait' },
  { value: 'MV', label: 'Maldives' },
  { value: 'MM', label: 'Myanmar' },
  { value: 'NP', label: 'Nepal' },
  { value: 'NG', label: 'Nigeria' },
  { value: 'OM', label: 'Oman' },
  { value: 'PK', label: 'Pakistan' },
  { value: 'QA', label: 'Qatar' },
  { value: 'SA', label: 'Saudi Arabia' },
  { value: 'LK', label: 'Sri Lanka' },
  { value: 'SD', label: 'Sudan' },
  { value: 'TZ', label: 'Tanzania' },
  { value: 'AE', label: 'United Arab Emirates' },
  { value: 'UG', label: 'Uganda' },
  { value: 'UZ', label: 'Uzbekistan' },
  { value: 'YE', label: 'Yemen' },
  { value: 'ZM', label: 'Zambia' },
  { value: 'OTHER', label: 'Other Country' },
];

// Languages
export const LANGUAGES = [
  { value: 'en', label: 'English' },
  { value: 'ar', label: 'Arabic (العربية)' },
  { value: 'bn', label: 'Bengali (বাংলা)' },
  { value: 'fr', label: 'French (Français)' },
  { value: 'hi', label: 'Hindi (हिन्दी)' },
  { value: 'ps', label: 'Pashto (پښتو)' },
  { value: 'fa', label: 'Persian/Farsi (فارسی)' },
  { value: 'pt', label: 'Portuguese (Português)' },
  { value: 'ru', label: 'Russian (Русский)' },
  { value: 'sw', label: 'Swahili (Kiswahili)' },
  { value: 'ur', label: 'Urdu (اردو)' },
  { value: 'other', label: 'Other' },
];

// Time periods
export const TIME_PERIODS = [
  { value: 'urgent', label: 'Urgent (Within 2 weeks)' },
  { value: 'within_month', label: 'Within a Month' },
  { value: '1_3_months', label: '1-3 Months' },
  { value: '3_6_months', label: '3-6 Months' },
  { value: 'flexible', label: 'Flexible / Not Sure' },
];

// Contact methods
export const CONTACT_METHODS = [
  { value: 'phone', label: 'Phone Call', icon: Phone },
  { value: 'whatsapp', label: 'WhatsApp', icon: MessageCircle },
  { value: 'email', label: 'Email', icon: Mail },
  { value: 'video', label: 'Video Call', icon: Globe },
];
